import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancel: {
    id: "email.templatesModal.cancel",
    defaultMessage: "Cancel",
    description: "Manage email templates modal - Cancel",
  },
  clearConfirmationCancel: {
    id: "email.templatesModal.clearConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Manage email templates modal - Clear confirmation cancel",
  },
  clearConfirmationOk: {
    id: "email.templatesModal.clearConfirmation.ok",
    defaultMessage: "Clear",
    description: "Manage email templates modal - Clear confirmation ok",
  },
  delete: {
    id: "email.templatesModal.delete",
    defaultMessage: "Delete",
    description: "Manage email templates modal - Delete",
  },
  deleteConfirmationCancel: {
    id: "email.templatesModal.deleteConfirmation.cancel",
    defaultMessage: "Cancel",
    description: "Manage email templates modal - Cancel",
  },
  deleteConfirmationOk: {
    id: "email.templatesModal.deleteConfirmation.ok",
    defaultMessage: "Delete",
    description: "Manage email templates modal - Delete",
  },
  deleteConfirmationText: {
    id: "email.templatesModal.deleteConfirmation.description",
    defaultMessage: "Deleting templates cannot be undone.",
    description: "Manage email templates modal - Are you sure you want to delete this template?",
  },
  emailTemplates: {
    id: "email.templatesModal.emailTemplates",
    defaultMessage: "Email Templates",
    description: "Manage email templates modal - Email Templates",
  },
  exitPreview: {
    id: "email.templatesModal.exitPreview",
    defaultMessage: "Exit Preview",
    description: "Manage email templates modal - exit preview",
  },
  lessTemplateUsersButtonLabel: {
    id: "email.templatesModal.lessTemplateUsersButtonLabel",
    defaultMessage: "Show Less",
    description: "Manage email templates modal - less template users button label",
  },
  moreTemplateUsersButtonLabel: {
    id: "email.templatesModal.moreTemplateUsersButtonLabel",
    defaultMessage: "+ {count} more",
    description: "Manage email templates modal - more template users button label",
  },
  noTemplatesDescription: {
    id: "email.templatesModal.noTemplatesDescription",
    defaultMessage:
      "You don’t have any templates yet.{br}Save a new template by composing an email.",
    description: "Manage email templates modal - No templates description",
  },
  noTemplatesTitle: {
    id: "email.templatesModal.noTemplatesTitle",
    defaultMessage: "No Templates",
    description: "Manage email templates modal - No templates",
  },
  okay: {
    id: "email.templatesModal.okay",
    defaultMessage: "Okay",
    description: "Manage email templates modal - Okay",
  },
  previewAs: {
    id: "email.templatesModal.previewAs",
    defaultMessage: "Preview As",
    description: "Manage email templates modal - Preview As",
  },
  previewAsDisabledTooltip: {
    id: "email.templatesModal.previewAsDisabledTooltip",
    defaultMessage: "Add a recipient to preview this template.",
    description: "Manage email templates modal - Preview As disabled tooltip",
  },
  previewModeTagLabel: {
    id: "email.templatesModal.previewModeTagLabel",
    defaultMessage: "Preview Mode",
    description: "Manage email templates modal - Preview Moode tag label",
  },
  previewTemplateDescription: {
    id: "email.templatesModal.previewTemplateDescription",
    defaultMessage:
      'The "Preview As" email feature lets you see how an email would look to a particular recipient, helping you check if personalized details are working correctly.',
    description: "Manage email templates modal - Preview Template Description",
  },
  rename: {
    id: "email.templatesModal.rename",
    defaultMessage: "Rename",
    description: "Manage email templates modal - Rename",
  },
  share: {
    id: "email.templatesModal.share",
    defaultMessage: "Share",
    description: "Manage email templates modal - Share",
  },
  shareDisabledDescription: {
    id: "email.templatesModal.shareDisabledDescription",
    defaultMessage: "This template was shared with you. Only the owner can share it.",
    description: "Manage email templates modal - Share disabled description",
  },
  shareTemplateModalSubTitle: {
    id: "email.templatesModal.shareModal.subTitle",
    defaultMessage: "Select teams and users below to share this email template.",
    description: "Manage email templates modal - share email template modal sub title",
  },
  shareTemplateModalTitle: {
    id: "email.templatesModal.shareModal.title",
    defaultMessage: "Share Email Template",
    description: "Manage email templates modal - share email template modal title",
  },
  subjectLabel: {
    id: "email.templatesModal.subjectLabel",
    defaultMessage: "Subject: {subject}",
    description: "Manage email templates modal - subject label",
  },
  templateUsersLabel: {
    id: "email.templatesModal.templateUsersLabel",
    defaultMessage: "Shared with {text}",
    description: "Manage email templates modal - Template users label",
  },
});

export default messages;
